import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, ChevronRight } from "lucide-react";
import { useOrderList } from "@/context/OrderListContext";

export const FloatingOrderButton = () => {
  const { count, setIsOpen } = useOrderList();

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          data-testid="floating-order-button"
          onClick={() => setIsOpen(true)}
          className="fixed bottom-5 left-5 z-40 hidden items-center gap-3 rounded-sm bg-bordo py-3 pl-4 pr-3 text-cream shadow-[0_12px_30px_-8px_rgba(122,26,26,0.6)] transition-colors hover:bg-bordo-dark lg:flex"
        >
          <span className="relative">
            <ShoppingBag className="h-5 w-5" />
            <span className="absolute -right-2 -top-2 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-cream px-1 font-mono text-[10px] font-bold text-bordo">
              {count}
            </span>
          </span>
          <span className="text-sm font-medium uppercase tracking-wide">Sipariş Listem</span>
          <ChevronRight className="h-4 w-4" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingOrderButton;
